angular.module('unica_location.location_services')

.factory('LocationCreateService', function($http, getBaseApiURL) {

	var locationCreateService = {};

	locationCreateService.create = function(locationData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/create',
			data: locationData
		}).then(function(result) {

			if ( result ) {
				return result.data.location;
			}

		});
	};

	return locationCreateService;

});